import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

const AuthProvider = ({ children }) => {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_API_AUDIENCE,
        scope: "openid profile email", // ✅ Ensures ID Token contains user info
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
